import FaqsPagination from './faqs-pagination';
import SelectionsTabSlider from 'components/selections-tab-slider';

function FaqsPage($element, options = {}) {
    this.$element = $element;
    this.options = options;

    this.$element.querySelectorAll('.js-show-more-faqs').forEach($button => new FaqsPagination($button));
    this.$element.querySelectorAll('.js-faq-tab-slider').forEach($slider => new SelectionsTabSlider($slider, {
        tab: {
            swiper: {
                pagination: {
                    el: '.faq-dots',
                    clickable: true,
                    bulletElement: 'li',
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 3,
                    },
                },
            },
        },
    }));
}

export default FaqsPage;
